export const defaultPermissions = {
  dashboard: true,

  reporting: true,
  rules: true,

  prospects: true,
  showings: true,
  referrals: true,
  lead_managing: false,

  applications: true,
  rent_roll: true,
  tenants: true,

  maintenance: true,
  recurring_tickets: true,
  ticket_scheduler: true,
  assets: true,
  vendors: true,
  inspections: true,
  escalation: true,
  inspection_templates: true,
  insight_dashboards: false,

  income: true,
  expenses: true,
  recurring_entries: true,
  journal: true,
  chart_of_accounts: true,

  payments: true,
  deposits: true,

  notices: true,
  amenities: true,
  events: true,
  parcels: true,
  promotions: true,
  surveys: true,
  visitors: true,
  logs: true,

  properties: true,
  users: true,
  messaging: true,

  calendar_kiosk: false,
  maintenance_tickets_kiosk: false,
  parcels_kiosk: false,

  api_dashboard_documents: false,
  api_dashboard_settings: false,

  company_settings: false,
  billing: false,
};

export const authorizedRoute = (route, userPermissions) => {
  if (!route) return false;

  const routeArr = route.split('/');
  let key = routeArr[routeArr.length - 1];
  if (key === 'tickets') {
    // from route, we get the last element after split to use to find by key in userPermissions
    // for maintenance tickets however, we use /companies/maintenance/ticket routing but maintenance as the key
    // so if last element is tickets, look for the key 'maintenance'
    key = 'maintenance';
  }

  return userPermissions[key] !== false;
};
